(() => {
  'use strict';
  const instances = new Map();
  const mount = (scope = document) => {
    const headers = [...scope.querySelectorAll('[data-editorial-header]')];
    if (scope.matches?.('[data-editorial-header]')) headers.unshift(scope);
    for (const header of headers) {
      if (instances.has(header)) continue;
      const section = header.closest('.lh-editorial-header-section');
      const toggle = header.querySelector('[data-editorial-menu-open]');
      const dialog = section?.querySelector('[data-editorial-menu]');
      if (!toggle || !dialog || typeof dialog.showModal !== 'function') continue;
      const controller = new AbortController();
      const listen = (target, type, handler, options = {}) => target?.addEventListener(type, handler, {...options, signal:controller.signal});
      const mobile = matchMedia('(max-width: 850px)');
      const buttons = [...dialog.querySelectorAll('[data-lh-menu-category]')];
      const panels = [...dialog.querySelectorAll('[data-lh-menu-panel]')];
      const back = dialog.querySelector('[data-lh-menu-back]');
      let selected = 'rings';
      let frame = 0;
      const select = (key, focus = false) => {
        selected = key;
        buttons.forEach(button => button.setAttribute('aria-expanded', String(button.dataset.lhMenuCategory === key)));
        panels.forEach(panel => { panel.hidden = panel.dataset.lhMenuPanel !== key; });
        dialog.toggleAttribute('data-submenu-open', Boolean(key));
        back.hidden = !mobile.matches || !key;
        if (focus && key) dialog.querySelector(`[data-lh-menu-panel="${key}"] a`)?.focus({preventScroll:true});
      };
      const reset = () => select(mobile.matches ? null : 'rings');
      const close = () => { if (dialog.open) dialog.close(); };
      const update = () => { frame = 0; if (header.hasAttribute('data-home-header')) header.classList.toggle('is-scrolled', scrollY > 48); };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      listen(toggle, 'click', () => {
        if (dialog.open) return;
        reset();
        dialog.showModal();
        toggle.setAttribute('aria-expanded', 'true');
        document.documentElement.setAttribute('data-lh-menu-open', '');
        dialog.querySelector('[data-editorial-menu-close]')?.focus({preventScroll:true});
      });
      buttons.forEach((button, index) => {
        listen(button, 'click', () => select(button.dataset.lhMenuCategory, mobile.matches));
        listen(button, 'keydown', event => {
          if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
          event.preventDefault();
          const next = buttons[(index + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length];
          next.focus();
          if (!mobile.matches) select(next.dataset.lhMenuCategory);
        });
      });
      listen(back, 'click', () => {
        const previous = selected;
        select(null);
        buttons.find(button => button.dataset.lhMenuCategory === previous)?.focus();
      });
      listen(dialog.querySelector('[data-editorial-menu-close]'), 'click', close);
      listen(dialog, 'keydown', event => { if (event.key === 'Escape') { event.preventDefault(); close(); } });
      listen(dialog, 'close', () => {
        toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.removeAttribute('data-lh-menu-open');
        if (toggle.isConnected) toggle.focus({preventScroll:true});
      });
      listen(dialog, 'click', event => { if (event.target.closest('a')) close(); });
      listen(mobile, 'change', () => { if (dialog.open) reset(); });
      listen(window, 'scroll', schedule, {passive:true});
      listen(window, 'pageshow', schedule);
      update();
      instances.set(header, () => { close(); controller.abort(); cancelAnimationFrame(frame); });
    }
  };
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [header, destroy] of instances) if (event.target.contains(header)) { destroy(); instances.delete(header); }
  });
})();
